import { ButtonHTMLAttributes, ReactElement } from "react";

import { cn } from "@/utils/tailwind.ts";

type SvIconButtonProps = {
  className?: string;
  icon: ReactElement;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const SvIconButton = ({
  icon,
  className,
  ...props
}: SvIconButtonProps) => {
  return (
    <button
      className={cn(
        "border-ind-grey-50 text-primary hover:border-primary hover:bg-primary-50 active:bg-primary rounded-sm border bg-white p-2 text-xl active:text-white",
        className,
      )}
      {...props}>
      {icon}
    </button>
  );
};
